import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';

import 'hammerjs';

import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeUI_Default = PhotoSwipeUI_Default;

import './bootstrap.accordion';
import './bootstrap.popover';
import './bootstrap.stickyheader';
import './bootstrap.smoothscroll';
// this already is jQuery-less in EXT:bootstrap_package 12.x, so we can directly include it
import '@ext-bootstrap-package/js/bootstrap.lightbox';
import './bootstrap.navbar';
// bootstrap.cookieconsent triggered a build error
